import { useEffect, useRef, createContext } from 'react';
import styled from 'styled-components';

export const DialogContext = createContext();

const Dialog = ({ onClose, children }) => {
  const dialogRef = useRef();

  useEffect(() => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  }, []);

  const close = () => {
    dialogRef.current.close();
    onClose();
  };

  // TODO: For some reason this calls close() when clicking modal buttons, resulting
  // in a double navigation
  const onClick = e => {
    // Close dialog when clicking backdrop
    const dialogDimensions = dialogRef.current.getBoundingClientRect();
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      close();
    }
  };

  return (
    <DialogContext.Provider value={{ isOpen: true, close }}>
      <StyledDialog ref={dialogRef} /* onClick={onClick} */>
        {children}
      </StyledDialog>
    </DialogContext.Provider>
  );
};

const StyledDialog = styled.dialog`
  border: none;
  z-index: 10;

  &::backdrop {
    background-color: black;
    opacity: 0.5;
  }

  padding: 80px;
  font-weight: 400;

  max-width: 800px;
`;

export default Dialog;
